export class TemplateColor{
    id : number = 0
    code : string = ""
}